<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigations -->
<bp-vertical-navigation
  class="text-white dark print:hidden bg-normal"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation?.bp!"
  [opened]="!isScreenSmall"
  [removeMargin]="true"
  [collapsed]="!isScreenSmall && sidebarCollapsed()"
  (expandRequested)="onSidebarExpandRequested()"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationHeader>
    @if (!isScreenSmall && sidebarCollapsed()) {
      <!-- Colapsado: monograma "B" + toggle apilados y centrados -->
      <div class="bp-sidebar-header flex flex-col items-center gap-2 pt-6 pb-0">
        <img
          (click)="goToDashboard()"
          class="w-7 h-7 cursor-pointer"
          src="assets/img/auxi/betterplan-b-white-blue.svg"
          alt="Betterplan"
          title="Betterplan"
        />
        <button
          type="button"
          mat-icon-button
          class="text-white"
          [attr.aria-label]="'Expandir menú lateral'"
          matTooltip="Expandir menú"
          (click)="toggleSidebarCollapsed()"
        >
          <mat-icon class="icon-size-5 text-white" svgIcon="bp:sidebar-toggle"></mat-icon>
        </button>
      </div>
    } @else {
      <!-- Expandido: wordmark + toggle (solo desktop) -->
      <div class="bp-sidebar-header flex items-center justify-between h-20 p-6 pb-0">
        @if (bgSidebar() === 'endow') {
          <img
            (click)="goToDashboard()"
            class="w-40 cursor-pointer"
            src="assets/images/logo/logo-betterplan-dark.svg"
          />
        } @else {
          <img
            (click)="goToDashboard()"
            class="w-40 cursor-pointer"
            src="assets/images/logo/logo-betterplan.svg"
          />
        }

        <!-- Toggle de colapso (solo desktop; en mobile manda la hamburguesa) -->
        @if (!isScreenSmall) {
          <button
            type="button"
            mat-icon-button
            class="text-white"
            [attr.aria-label]="'Colapsar menú lateral'"
            matTooltip="Colapsar menú"
            (click)="toggleSidebarCollapsed()"
          >
            <mat-icon class="icon-size-5 text-white" svgIcon="bp:sidebar-toggle"></mat-icon>
          </button>
        }
      </div>
    }
  </ng-container>

  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationFooter>
    <!-- User -->
    <div class="bp-sidebar-user flex items-center w-full px-6 py-8 border-t">
      <!-- User rounded button -->
      <bp-user></bp-user>

      <!-- User names and email (se ocultan en estado colapsado vía CSS) -->
      <div class="bp-sidebar-user-meta flex flex-col w-full ml-4 overflow-hidden">
        <div
          class="w-full overflow-hidden leading-normal text-current text-ellipsis opacity-80"
          [ngClass]="{ 'whitespace-nowrap': user?.userType !== 'entity' }"
        >
          {{ user?.firstname }} {{ user?.surname }}
        </div>
        @if (user?.userType !== 'entity') {
          <div
            class="w-full mt-0.5 whitespace-nowrap text-sm text-ellipsis overflow-hidden leading-normal text-current opacity-50"
          >
            {{ user?.email }}
          </div>
        }
      </div>
    </div>
  </ng-container>
</bp-vertical-navigation>

<!-- Wrapper -->
<!-- `pb-safe-bottom`: el contenido tambien llega al borde inferior de la pantalla, asi
  que el ultimo bloque (footer, botones al final de una vista) se separa del home
  indicator del iPhone en vez de quedar tapado por el. -->
<div class="flex flex-col flex-auto w-full min-w-0 pb-safe-bottom">
  <div #anchorElement></div>
  <!-- Header -->
  <!-- El app bar se extiende por debajo de la status bar (`pt-safe-top` + alto
    `h-app-bar`): asi su fondo — y el blur cuando hay scroll — llega hasta el borde
    superior de la pantalla en vez de cortarse en una linea. En el navegador los
    safe areas valen 0 y esto equivale al `h-16` de siempre. -->
  <div
    class="grid grid-cols-[auto,1fr,auto] items-center bg-card w-full h-app-bar pt-safe-top px-4 z-49 dark:shadow-none dark:border-b dark:bg-transparent print:hidden md:relative fixed top-0 md:shadow-none"
    [ngClass]="{
      'bg-transparent': hasTransparentAppBar,
      ' bg-white': !hasTransparentAppBar,
      'shadow transition-all duration-300 bg-white-blur backdrop-blur-md ': shadow,
      ' transition-all duration-200 ': !shadow,
      'hidden': !isScreenSmall && (isHome || hideAppBarOnDesktop),
    }"
  >
    <!-- Leading -->
    @if (headerConfig?.leading) {
      <ng-container [ngTemplateOutlet]="headerConfig?.leading ?? null"></ng-container>
    } @else if (!isScreenSmall) {
      <!-- Desktop: el control del sidebar es el toggle del propio sidebar. En NINGUNA
        ruta se muestra hamburguesa ni botón back; solo el placeholder que mantiene la
        columna del grid. -->
      <div class="min-w-[38px]"></div>
    } @else if (isHome) {
      <!-- Mobile Home: hamburguesa (sidebar en modo 'over') -->
      <div>
        <button mat-icon-button color="accent" (click)="toggleNavigation('mainNavigation')">
          <mat-icon class="text-accent" [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
      </div>
    } @else {
      <!-- Mobile resto de rutas: hamburguesa o back según config de la ruta -->
      @if (showHamburguerOnDefaultLeading) {
        <div>
          <button
            class=""
            mat-icon-button
            color="accent"
            (click)="toggleNavigation('mainNavigation')"
          >
            <mat-icon class="text-accent" [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
          </button>
        </div>
      } @else {
        <div class="flex flex-row justify-end">
          <button mat-icon-button (click)="goBack()">
            <mat-icon
              class="text-accent"
              [svgIcon]="'heroicons_outline:arrow-small-left'"
            ></mat-icon>
          </button>
        </div>
      }
    }

    <!-- Center -->
    @if (headerConfig?.center) {
      <div
        [ngClass]="{
          'md:hidden': headerConfig?.hideFrom === 'md',
          'lg:hidden': headerConfig?.hideFrom === 'lg',
          'xl:hidden': headerConfig?.hideFrom === 'xl',
          'hidden md:block': headerConfig?.showFrom === 'md',
          'hidden lg:block': headerConfig?.showFrom === 'lg',
          'hidden xl:block': headerConfig?.showFrom === 'xl',
        }"
      >
        <ng-container [ngTemplateOutlet]="headerConfig?.center ?? null"></ng-container>
      </div>
    } @else if (scrollHeaderContent) {
      <!-- Scroll-based dynamic content (only visible on mobile when element is out of view) -->
      <div @fadeIn class="flex items-center justify-center md:hidden">
        <ng-container [ngTemplateOutlet]="scrollHeaderContent"></ng-container>
      </div>
      <!-- Default logo for desktop -->
      <div class="items-center justify-center hidden md:flex"></div>
    } @else if (!hideAppBarLogo) {
      <!-- La "B" solo se pinta si la vista no pidió ocultarla: las que ya muestran su propia
           identidad (meta, acción) la ocultan para que el centro quede libre hasta que el
           scroll traiga el avatar + nombre (ver BpHeaderService.setHideAppBarLogo). -->
      <div @fadeIn class="flex justify-center items center">
        <!-- aquí se añade la clase de centrado de texto -->
        <img
          (click)="goToDashboard()"
          class="block w-6 h-6 cursor-pointer md:hidden"
          src="assets/img/auxi/betterplan-b-dark.svg"
          alt="Betterplan"
          title="Betterplan"
          width="24"
          height="24"
          [style.viewTransitionName]="'betterplan-logo-mobile'"
        />
      </div>
    } @else {
      <!-- Placeholder: mantiene viva la columna central del grid. -->
      <div></div>
    }

    <!-- Action -->
    @if (headerConfig?.action) {
      <ng-container [ngTemplateOutlet]="headerConfig?.action ?? null"></ng-container>
    } @else {
      <div class="min-w-[38px]"></div>
    }
  </div>
  <!-- Content -->
  <!-- Cuando el app bar está oculto en desktop (Home o vistas que lo piden vía
    BpHeaderService) agregamos un padding-top extra para que el contenido no quede
    pegado al borde superior. Solo md+. -->
  <div
    class="flex flex-col flex-auto mt-app-bar md:mt-0"
    [ngClass]="{ 'md:pt-6': isHome || hideAppBarOnDesktop }"
  >
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
      Otherwise, layout changes won't be registered and the view won't be updated! -->

    <router-outlet></router-outlet>
  </div>

  <!-- Footer -->
  @if (!routerUrl.includes('/profile')) {
    <div
      class="relative flex flex-col items-start justify-center w-full max-w-screen-xl px-4 pt-10 mx-auto flex-0 md:px-6 z-49 dark:bg-transparent print:hidden"
    >
      <div class="flex flex-wrap items-center mb-6 gap-y-3 gap-x-4">
        <a
          href="https://intercom.help/betterplan-advisors/es"
          target="_blank"
          rel="noopener noreferrer"
          class="text-secondary hover:underline"
          >Preguntas frecuentes</a
        >
        <a (click)="openIntercomChat($event)" class="cursor-pointer text-secondary hover:underline">
          Escríbenos
        </a>
        <a
          href="https://storage.googleapis.com/betterplan-prod-public/goal/documents/asesores-betterplan.pdf"
          target="_blank"
          rel="noopener noreferrer"
          class="text-secondary hover:underline"
        >
          Asesores
        </a>
        <a
          [href]="fileUrlBase + config?.termsAndConditionsId + '/?token=' + token"
          target="_blank"
          class="text-secondary hover:underline"
          >Términos y condiciones</a
        >
        <a
          href="https://www.cmfchile.cl/institucional/mercados/entidad.php?auth=&send=&mercado=O&rut=77084652&grupo=&tipoentidad=RGPSF&vig=VI&control=svs&pestania=1"
          target="_blank"
          rel="noopener noreferrer"
          class="text-secondary hover:underline"
          >CMF
        </a>
        <a
          [href]="fileUrlBase + config?.codeOfConductId?.value + '/?token=' + token"
          target="_blank"
          rel="noopener noreferrer"
          class="text-secondary hover:underline"
          >Código de conducta</a
        >
        <a
          [href]="landingNewUrlContactForm"
          target="_blank"
          rel="noopener noreferrer"
          class="text-secondary hover:underline"
          >Feedback</a
        >
      </div>
      <div class="flex flex-wrap items-center justify-between w-full mb-4 gap-y-6">
        <span class="text-secondary"> {{ currentYear }}, Betterplan Advisors SpA. </span>
        <span class="text-transparent">
          <a href="/clear"> Version: {{ env.version }}-{{ env.name }} </a></span
        >
      </div>
    </div>
  }
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
